import React from "react";
import "./select.scss";
import "../../../styles/fontSizes.scss";

//SizeType puede ser 1, 2, 3, 4...
//type puede ser h -> h1 h2, etc o p -> párrafo
//fontWeight puede ser 100, 200, 300 o 400.
/* Estructura de datos para Select: 
groupName = ,
default = ,
        options = [{
            text: ,
            value:
        }],
*/
const Select = ({ data, textSize, className, setOption }) => {
  function handleChange(e) {
    setOption(e.target.value);
  }
  return (
    <>
      {data ? (
        <select
          onChange={(e) => handleChange(e)}
          className={`select__container font-size--${textSize} ${
            className ? className : ""
          }`}
        >
          {data.options ? (
            data.options.map((value, index) => (
              <option
                key={index}
                selected={value.value == data.default ? "selected" : ""}
                value={value.value}
              >
                {value.text}
              </option>
            ))
          ) : (
            <option value="Error">Faltan las opciones</option>
          )}
        </select>
      ) : (
        <p>Faltan los datos en select input</p>
      )}
    </>
  );
};

export default Select;
